export default __webpack_public_path__ + "static/media/ucb-logo-transparent.b9f03698.png";